import { createActions } from 'redux-actions';
import { upload } from '../../services';

const {
  scrapeRequest,
  scrapeSuccess,
  scrapeFailure,
} = createActions({
  SCRAPE_SUCCESS: json => json,
}, 'SCRAPE_REQUEST', 'SCRAPE_FAILURE');

export function scraper(formData) {
  return (dispatch) => {
    dispatch(scrapeRequest());
    return upload(formData, 'scrapers')
      .then(({ json }) => dispatch(scrapeSuccess(json)))
      .catch(error => dispatch(scrapeFailure(error)));
  };
}



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/scraper.js